import type { AnswerValue } from '@repo/contracts/cardfinder/funnel/types';

export function serializeActionInput(answer: AnswerValue): string {
  if (answer === undefined) return 'skip';
  if (Array.isArray(answer)) return answer.length > 0 ? answer.join(', ') : 'skip';
  return String(answer);
}

export function getFieldType(answer: AnswerValue): string | undefined {
  if (Array.isArray(answer)) return 'checkbox';
  if (typeof answer === 'number') return 'number';
  if (typeof answer === 'string') return 'radio';
  return undefined;
}
